<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'study-editor.planting-preparation.modal.title' | translate }}</h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="row mb-3">
            <div class="col-xs-12 col-md-12">
                <span class="fw-bold">
                    <span class="badge rounded-pill bg-secondary fs-6">{{numberOfPlots}}</span>
                    {{'study-editor.planting-preparation.modal.plots-selected-for' | translate}}
                    <span class="badge rounded-pill bg-secondary fs-6">{{numberOfInstances}}</span>
                    {{'study-editor.planting-preparation.modal.instances' | translate}}
                </span>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-xs-12 col-md-12">
                <div class="container-fluid p-0 custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;">
                    <table class="table table-curved table-bordered table-striped table-fit">
                        <thead class="sticky-header">
                        <tr>
                            <th>{{ 'study-editor.planting-preparation.unit-table.column-header.unit' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.unit-table.column-header.no-of-valid-lot-status' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.unit-table.column-header.group-transactions' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.unit-table.column-header.withdraw-all-available-inventory' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.unit-table.column-header.use-entry-detail-variable' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.unit-table.column-header.amount-per-packet' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        @if (units && size(units) > 0) {
                            <tr *ngFor="let unit of units | keyvalue">
                                <td>{{ unit?.value?.unitName }}</td>
                                <td>{{ validLotsCount(unit.key) }}</td>
                                <td><input class="form-check-input" type="checkbox"  (change)="onGroupTransactionsChecked(unit.key, unit.value)"
                                           [(ngModel)]="unit.value.groupTransactions"/></td>
                                <td><input  class="form-check-input" type="checkbox" (change)="onWithdrawAllChecked(unit.key, unit.value)"
                                            [(ngModel)]="unit.value.withdrawAll"
                                            [disabled]="!unit.value.groupTransactions || unit.value.useEntryDetail"/></td>
                                <td><input   class="form-check-input" type="checkbox" (change)="onUseEntryDetailChecked(unit.key, unit.value)"
                                             [(ngModel)]="unit.value.useEntryDetail" [disabled]="unit.value.withdrawAll"/></td>
                                <td *ngIf="!unit.value.useEntryDetail">
                                    <input type="text" class="form-control" style="width: 200px;"
                                           (change)="onAmountPerPacketChanged(unit.key, unit.value)"
                                           [(ngModel)]="unit.value.amountPerPacket"
                                           [disabled]="unit.value.withdrawAll || unit.value.useEntryDetail"/>
                                </td>
                                <td *ngIf="unit.value.useEntryDetail">
                                    <ng-select class="entry-detail" appendTo=".modal-body" id="useEntryDetail"
                                               name="useEntryDetail" [items]="entryDetailVariables"
                                               [(ngModel)]="unit.value.variableSelected"
                                               (change)="onAmountPerPacketByEntryDetailChanged(unit.key, unit.value)"
                                               required style="width: 200px;">
                                        <ng-template ng-label-tmp let-item="item">
                                            {{ item?.name }}
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            {{ item?.name }}
                                        </ng-template>
                                    </ng-select>
                                </td>
                            </tr>
                        } @else {
                            <tr>
                                <td [attr.colspan]="6" class="text-center py-3">
                                    {{ 'study-editor.no-records' | translate }}
                                </td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
        <div class="row mb-3">
            <div class="col-xs-12 col-md-12">
                <div class="container-fluid p-0 custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;">
                    <table class="table table-curved table-striped table-condensed table-no-wrap" style="width: 100%">
                        <thead class="sticky-header">
                        <tr>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.entry-no' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.entry-type' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.gid' | translate }}</th>
                            <th *ngIf="principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSIONS)">{{ 'study-editor.planting-preparation.entries-table.column-header.designation' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.stock-id' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.storgae-location' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.available-balance' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.number-of-packets' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.units' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.withdrawal' | translate }}</th>
                            <th>{{ 'study-editor.planting-preparation.entries-table.column-header.transaction-status' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        @if (entries && entries.length) {
                            <tr *ngFor="let entry of entries">
                                <td>{{entry?.entryNo}}</td>
                                <td>{{entry?.entryType}}</td>
                                <td>{{entry?.gid}}</td>
                                <td *ngIf="principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSIONS)"><truncate-span [textInput]="entry?.designation" [maxLength]="20"></truncate-span></td>
                                <td>
                                    <ng-select appendTo=".modal-body" *ngIf="size(entry.stockByStockId) > 1" [(ngModel)]="entry.stockSelected" (change)="stockIdChange(entry)" [clearable]="false">
                                        <ng-option *ngFor="let item of entry.stockByStockId | keyvalue" [value]="item.value">{{item.key}}</ng-option>
                                    </ng-select>
                                    <span *ngIf="size(entry.stockByStockId) == 1">{{keys(entry.stockByStockId)[0]}}</span>
                                </td>
                                <td><truncate-span [textInput]="entry?.stockSelected?.storageLocation" [maxLength]="20"></truncate-span></td>
                                <td>{{entry?.stockSelected?.availableBalance}}</td>
                                <td>{{entry?.numberOfPackets}}</td>
                                <td>{{units[entry?.stockSelected?.unitId]?.unitName}}</td>
                                <td>{{(units[entry?.stockSelected?.unitId]?.withdrawAll && entry?.stockSelected?.availableBalance)
                                || withdrawalCalculator(entry?.stockSelected?.unitId, entry?.entryNo, entry?.numberOfPackets)}}
                                </td>
                                <td style="font-size: 1.3rem">
                                    <span class="fa fa-check-circle text-success" *ngIf="entry?.valid"></span>
                                    <span class="fa fa-ban text-danger" *ngIf="!entry?.valid"></span>
                                </td>
                            </tr>
                        } @else {
                            <tr>
                                <td [attr.colspan]="principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSIONS)? 11 : 10" class="text-center py-3">
                                    {{ 'study-editor.no-records' | translate }}
                                </td>
                            </tr>
                        }

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="form-horizontal mb-3">
            <div class="row mb-3 form-group">
                <label class="col-sm-1 fw-bold" for="txtNotes">{{ 'study-editor.planting-preparation.note' | translate}}</label>
                <div class="col-sm-5">
                    <textarea id="txtNotes" rows="4" class="form-control" [(ngModel)]="notes" (change)="validateNotes()"></textarea>
                </div>
            </div>
            <div class="checkbox col-sm-offset-1" *ngIf="principal.hasAnyAuthorityDirect(MS_CREATE_CONFIRMED_WITHDRAWALS)">
                <label class="col-sm-5 nopadding">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="isCommitOnSaving" />
                    {{'study-editor.planting-preparation.commit-withdrawal-on-saving' | translate}}
                </label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancel()">{{ 'cancel' | translate}}</button>
        <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!valid() || notesInvalid">{{ 'confirm' | translate}}</button>
    </div>
</div>
